/* Independent of the product form, cart and Shade Studio. */
(() => {
  if (customElements.get('reneora-before-after')) return;
  class ReneoraBeforeAfter extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.stage = this.querySelector('[data-compare-stage]');
      this.panels = [...this.querySelectorAll('[data-compare-panel]')];
      this.buttons = [...this.querySelectorAll('[data-compare-profile]')];
      if (!this.stage || !this.panels.length) return;
      this.position = Math.max(0, Math.min(100, Number.isFinite(Number(this.dataset.start)) ? Number(this.dataset.start) : 50));
      this.querySelectorAll('[data-compare-endpoint]').forEach(button => button.addEventListener('click', () => this.setPosition(Number(button.dataset.compareEndpoint)), options));
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, options);
      this.stage.addEventListener('keydown', event => {
        const steps = { ArrowLeft: -2, ArrowDown: -2, ArrowRight: 2, ArrowUp: 2, PageDown: -10, PageUp: 10 };
        if (event.key === 'Home') this.setPosition(0);
        else if (event.key === 'End') this.setPosition(100);
        else if (Object.hasOwn(steps, event.key)) this.setPosition(this.position + steps[event.key]);
        else return;
        event.preventDefault();
      }, options);
      this.stage.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary) return;
        this.pointer = event.pointerId;
        this.stage.setPointerCapture(event.pointerId);
        this.stage.focus({ preventScroll: true });
        this.move(event);
      }, options);
      this.stage.addEventListener('pointermove', event => {
        if (event.pointerId === this.pointer) this.move(event);
      }, options);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => this.stage.addEventListener(name, () => { this.pointer = null; }, options));
      this.addEventListener('dragstart', event => event.preventDefault(), options);
      this.select(0);
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    setPosition(value) {
      this.position = Math.max(0, Math.min(100, value));
      this.style.setProperty('--rn-ba-position', `${this.position}%`);
      this.stage.setAttribute('aria-valuenow', String(Math.round(this.position)));
      const before = this.dataset.beforeLabel || 'Before';
      const after = this.dataset.afterLabel || 'After';
      this.stage.setAttribute('aria-label', `${before} / ${after}`);
      this.querySelectorAll('[data-compare-endpoint]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.compareEndpoint) === this.position)));
      this.stage.setAttribute('aria-valuetext', `${before} ${100 - Math.round(this.position)}%, ${after} ${Math.round(this.position)}%`);
    }
    move(event) {
      const rect = this.stage.getBoundingClientRect();
      if (rect.width > 0) this.setPosition((event.clientX - rect.left) / rect.width * 100);
    }
    select(index) {
      if (!this.panels[index]) return;
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      const panel = this.panels[index];
      panel.querySelectorAll('img[data-src]').forEach(img => {
        if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
        img.src = img.dataset.src;
        delete img.dataset.src;
      });
      const caption = this.querySelector('[data-compare-caption]');
      if (caption) caption.textContent = panel.dataset.caption || '';
      this.setPosition(this.position);
    }
  }
  customElements.define('reneora-before-after', ReneoraBeforeAfter);
})();
